export enum ProductsEnums {
  APPROVED = 'approved',
  DRAFT = 'draft',
  DECLINED = 'declined',
  IN_REVIEW = 'in-review',
}
